// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"87e17c33","12":"caaf4c5c","48":"a1c5b188","54":"adcf6f79","88":"be6ceb13","200":"15131af8","332":"42c6b774","388":"f5a80f2b","414":"d07fd197","444":"813f69df","456":"a36efac1","824":"d093d794","880":"90f302fb","888":"f0874208","964":"0e08fe1d"}[chunkId] + ".chunk.js";
};